/* Change this file to get your personal Portfolio */

// Summary And Greeting Section

import emoji from "react-easy-emoji";

const illustration = {
  animated: true // set to false to use static SVG
};

const greeting = {
  username: "Nwatu Victor Praise",
  title: "Hi all, I'm Victor",
  subTitle: 
    "A passionate Frontend Developer 🚀 having an experience of designing and building Web and Mobile applications with JavaScript / Reactjs / Angular and some other cool libraries and frameworks."
  ,
  resumeLink:
    "https://drive.google.com/file/d/1TMrTK7vZUWrJYtaprqgA4qgjPzEMnc96/view?usp=sharing",
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/victor-praise",
   linkedin: "https://www.linkedin.com/in/victor-nwatu/",
  gmail: "nwatu.victor12@gmail.com",
  // gitlab: "https://gitlab.com/",
  // facebook: "https://www.facebook.com/",
  //medium: "https://medium.com/@davidrakosi",
  //stackoverflow: "https://stackoverflow.com/users/13263979/drakosi",
  //instagram: 'https://www.instagram.com/davidrakosi/',
  //twitter: 'https://twitter.com/davidrakosi_',
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "CRAZY FULL STACK DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    
      "⚡ Develop highly interactive Front end / User Interfaces for your web and mobile applications"
    ,
    "⚡ Progressive Web Applications ( PWA ) in normal and SPA Stacks",
   
      "⚡ Integration of third party services such as Firebase/ AWS / Digital Ocean"
    
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "sass",
      fontAwesomeClassname: "fab fa-sass"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "Reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "Angular",
      fontAwesomeClassname: "fab fa-angular"
    },
    {
      skillName: "PHP",
      fontAwesomeClassname: "fab fa-php"
    },
    {
      
      skillName: "C++",
      fontAwesomeClassname: "fas fa-code"
    },
    {
      skillName: "Java",
      fontAwesomeClassname: "fab fa-java"
    },
  
    { skillName: "Node.js",  fontAwesomeClassname: "fab fa-node-js" },
    {
      skillName: "NPM",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Concordia University",
      logo: require("./assets/images/Concordia_logo.jpg"),
      subHeader: "Masters of Applied Computer Science",
      duration: "September 2022 - June 2024",
      //desc: "Student Advisor for National association for Physics students.",
      // descBullets: [
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      // ]
    },
    {
      schoolName: "Concordia University",
      logo: require("./assets/images/Concordia_logo.jpg"),
      subHeader: "Graduate diploma in Computer Science",
      duration: "September 2021 - August 2022",
      //desc: "Student Advisor for National association for Physics students.",
      // descBullets: [
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      // ]
    },
    {
      schoolName: "Bachelor of Science in Industrial Physics",
      logo: require("./assets/images/CU_LOGO.9d7ad317.jpg"),
      subHeader: "Bachelor of Science in Industrial Physics",
      duration: "August 2015 - July 2019",
      desc:
        "Student Advisor for National association for Physics students.",
      // descBullets: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit"]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: false, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend / Design", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "70%"
    },
    {
      Stack: "Programming",
      progressPercentage: "90%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Frontend Developer",
      company: "Northsnow",
      companylogo: require("./assets/images/WhatsApp Image 2021-04-02 at 5.15 1.png"),
      date: "March 2022 –December 2022",
      desc:
        "Connecting employers to employees",
      descBullets: [
        "Responsible for building and maintaining an Admin Portal used by clients to manage and control activities of employees."
     
      ]
    },
    {
      role: "Frontend Developer",
      company: "GIG Logistics",
      companylogo: require("./assets/images/GIGLogin.png"),
      date: "January 2020 – October 2021",
      desc:
        "Leading Logistics company in Nigeria.",
      descBullets: [
        
        "Developed a Customer portal used by thousands of customers in Nigeria, Ghana, USA and UK",
        "Developed a portal used by third party partners in UK",
        "Responsible for providing technical support to clients",
        "Responsible for designing email templates"
     
      ]
    },
    {
      role: "Intern",
      company: "NNPC",
      companylogo: require("./assets/images/NNPC.145462e1.png"),
      date: "January 2018 – June 2018",
      desc:
        "",
      descBullets:[
        "Configuration of internet connection (Setting up Wi-Fi and LAN connection)",
        "Troubleshooting internet connectivity issues (faulty Lan ports, faulty LAN cables, disconnected from Switch or patch panel)",
      ]
    },
    // {
    //   role: "Junior Information Security & Systems Representative",
    //   company: "Vodafone",
    //   companylogo: require("./assets/images/vodafoneLogo.png"),
    //   date: "November 2018 – July 2019",
    //   desc:
    //     "I've conducted internal audit making sure the organization is compliant with the GDPR."
    // }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  githubConvertedToken: process.env.REACT_APP_GITHUB_TOKEN,
  githubUserName: "drakosi99", // Change to your github username to view your profile in Contact Section.
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Projects",
  subtitle: "",
  projects: [
    {
      image: require("./assets/images/ChatGPT Image Sep 16, 2025, 06_05_08 PM.png"),
      projectName: "AI Powered Receipt Tracker",
      projectDesc: "A web application that uses AI to extract and track receipt data.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://next-js-receipt-tracker.vercel.app/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/ChatGPT Image Nov 25, 2025, 11_59_13 PM.png"),
      projectName: "AI Powered Video Analyzer",
      projectDesc: "A sleek, web app representing intelligent video analysis and data extraction using AI",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://ai-content-manager-ecru.vercel.app/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/spotify2019-830x350.79e157ad.jpg"),
      projectName: "Spotify Clone",
      projectDesc: "",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://spotify-clone-67e8e3.netlify.app/"
        }
      ]
    },
    {
      image: require("./assets/images/1920px-Netflix_2015_logo.svg.png"),
      projectName: "Netflix",
      projectDesc: "",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://netflix-clone-7c1df2.netlify.app"
        }
      ]
    },
    // {
    //   image: require("./assets/images/pexels-anton-4132538.ddc9e0b1.jpg"),
    //   projectName: "Whatsapp clone",
    //   projectDesc: "A clone of whatsapp with multiple devices messaging",
    //   footerLink: [
    //     {
    //       name: "Visit Website",
    //       url: "https://whatsapp-clone-25dc6.firebaseapp.com/rooms/GhctZgyZy1PtxbUFgReW"
    //     }
    //   ]
    // },
    {
      image: require("./assets/images/pexels-maria-orlova-4969918.f529034e.jpg"),
      projectName: "Random User Genarator",
      projectDesc: "Generates random users",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://randomusergenerator-ab9cd6.netlify.app"
        }
      ]
    },
    {
      image: require("./assets/images/covid.86282711.webp"),
      projectName: "Covid-19 tracker",
      projectDesc: "Covid 19 tracker able to track across country",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://covid-19-tracker-b9c02b.netlify.app/"
        }
      ]
    },
    {
      image: require("./assets/images/pexels-suzy-hazelwood-2536965.7278cb4b.jpg"),
      projectName: "Ecommerce",
      projectDesc: "An ecommerce site",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://ecommerce-hawking-347706.netlify.app/"
        }
      ]
    },
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Google Code-In Finalist",
      subtitle:
        "First Pakistani to be selected as Google Code-in Finalist from 4000 students from 77 different countries.",
      image: require("./assets/images/codeInLogo.webp"),
      footerLink: [
        {
          name: "Certification",
          url:
            ""
        },
        {
          name: "Award Letter",
          url:
            ""
        },
        {
          name: "Google Code-in Blog",
          url:
            ""
        }
      ]
    },
    {
      title: "Google Assistant Action",
      subtitle:
        "Developed a Google Assistant Action JavaScript Guru that is available on 2 Billion devices world wide.",
      image: require("./assets/images/googleAssistantLogo.webp"),
      footerLink: [
        {
          name: "View Google Assistant Action",
          url:
            ""
        }
      ]
    },

    {
      title: "PWA Web App Developer",
      subtitle: "Completed Certifcation from SMIT for PWA Web App Development",
      image: require("./assets/images/pwaLogo.webp"),
      footerLink: [
        {name: "Certification", url: ""},
        {
          name: "Final Project",
          url: ""
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",

  blogs: [
    {
      url:
        "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    ""
  ),

  talks: [
    {
      title: "",
      subtitle: "",
      slides_url: "",
      event_url: ""
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    ""
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: "Contact Me ☎️",
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "(1) 514 8142678",
  email_address: "nwatu.victor12@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "davidrakosi_", //Replace "twitter" with your twitter username without @
  display: false// Set true to display this section, defaults to false
};

export {
  illustration,
  greeting,
  socialMediaLinks,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails
};
